import { FC } from "react";
import style from "./style.module.css";

interface BackdropProps {
  onClick?: () => void;
  // Each caller sits at a different point in its own stacking context
  // (e.g. Sidebar's drawer vs. CheckoutPage's mobile cart dock), so the
  // z-index has to stay per-consumer rather than baked into the shared
  // style — only the fixed/inset/background dimming itself is shared.
  zIndex: number;
}

// Shared full-viewport dimming layer for a mobile slide-in/slide-up panel
// (Sidebar's drawer, CheckoutPage's mobile cart dock, and any future one) —
// extracted so the fixed/inset/background overlay pattern has one place to
// change instead of being re-declared per consumer.
const Backdrop: FC<BackdropProps> = ({ onClick, zIndex }) => (
  <div className={style.backdrop} style={{ zIndex }} onClick={onClick} />
);

export default Backdrop;
